export const accountAppUrl = {
	cpURL: process.env.REACT_APP_URL
}

export const inboxAppUrl = {
	cpURL: process.env.REACT_APP_INBOX_URL
}
